import { PlusOutlined } from "@ant-design/icons";
import { Button, Select, Switch, Upload } from "antd";
import {
  beddingOptions,
  facilityOptions,
  roomTypeOptions,
  roomViewOptions,
} from "./const";
import { useAddRoom } from "./modules/useAddRoom";
import { formatCurrency } from "../../../utils/formatCurrency";
const {
  DragDropContext,
  Droppable,
  Draggable,
} = require("react-beautiful-dnd");

const { Option } = Select;

function AddRoomTemplate() {
  const {
    addRoom,
    handleFacilityChange,
    handleImageChange,
    loading,
    errors,
    room,
    setRoom,
    setErrors,
    imageFiles,
    reorderImages,
    handleImageRemove,
  } = useAddRoom();
  const {
    name,
    type,
    rentperday,
    maxcount,
    description,
    maxadult,
    maxchild,
    roomview,
    roomsize,
    bedding,
    facilities,
    manualBeds,
    extrabed,
    smokingpolicy,
  } = room;

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  // Drag-and-drop logic for images
  const onImagesDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (
      source.droppableId === "images" &&
      destination.droppableId === "images"
    ) {
      if (source.index === destination.index) return;
      reorderImages(source.index, destination.index);
    }
  };

  return (
    <div className="row ms-5 mb-5 me-5">
      <h1>ADD YOUR NEW ROOM</h1>
      <div className="col-md-6">
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Room Name
            </strong>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Room Name"
            value={name}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, name: e.target.value }))
            }
          />
          {errors.name && <span className="text-danger">{errors.name}</span>}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Room Rate
            </strong>
          </label>
          <input
            type="text"
            className={`form-control ${errors.rentperday ? "is-invalid" : ""}`}
            placeholder="Room Rate"
            value={
              rentperday
                ? formatCurrency(
                    Number(rentperday.toString().replace(/\./g, ""))
                  )
                : ""
            }
            onChange={(e) => {
              const rawValue = e.target.value.replace(/\./g, "");
              setRoom((prev) => ({ ...prev, rentperday: rawValue }));
            }}
            onKeyDown={(e) => {
              if (
                !/^\d*$/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete"
              ) {
                e.preventDefault();
                setErrors((prev) => ({
                  ...prev,
                  rentperday: "Only numbers are allowed.",
                }));
              } else {
                setErrors((prev) => ({ ...prev, rentperday: "" })); // Clear error
              }
            }}
          />
          {errors.rentperday && (
            <span className="text-danger">{errors.rentperday}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Number of Rooms
            </strong>
          </label>
          <input
            type="text"
            className={`form-control ${errors.maxcount ? "is-invalid" : ""}`}
            placeholder="Number of Rooms"
            value={maxcount}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, maxcount: e.target.value }))
            }
            onKeyDown={(e) => {
              if (
                !/^\d*$/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete"
              ) {
                e.preventDefault();
                setErrors((prev) => ({
                  ...prev,
                  maxcount: "Only numbers are allowed.",
                }));
              } else {
                setErrors((prev) => ({ ...prev, maxcount: "" })); // Clear error
              }
            }}
          />
          {errors.maxcount && (
            <span className="text-danger">{errors.maxcount}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Description
            </strong>
          </label>
          <textarea
            className="form-control"
            placeholder="Description"
            value={description}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, description: e.target.value }))
            }
            rows={5} // Set height for bigger input
          />
          {errors.description && (
            <span className="text-danger">{errors.description}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Maximum Adults
            </strong>
          </label>
          <input
            type="number"
            className="form-control"
            placeholder="Maximum Adults"
            value={maxadult}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, maxadult: e.target.value }))
            }
          />
          {errors.maxadult && (
            <span className="text-danger">{errors.maxadult}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Maximum Children
            </strong>
          </label>
          <input
            type="number"
            className="form-control"
            placeholder="Maximum Children"
            value={maxchild}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, maxchild: e.target.value }))
            }
          />
          {errors.maxchild && (
            <span className="text-danger">{errors.maxchild}</span>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Room Type
            </strong>
          </label>
          <select
            className="form-control"
            placeholder="Select Room Type"
            value={type}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, type: e.target.value }))
            }
          >
            <option value="">Select Room Type</option>
            {roomTypeOptions.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          {errors.type && <span className="text-danger">{errors.type}</span>}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Room View
            </strong>
          </label>
          <select
            className="form-control"
            placeholder="Select Room View"
            value={roomview}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, roomview: e.target.value }))
            }
          >
            <option value="">Select Room View</option>
            {roomViewOptions.map((view) => (
              <option key={view} value={view}>
                {view}
              </option>
            ))}
          </select>
          {errors.roomview && (
            <span className="text-danger">{errors.roomview}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Room Size (sq meters)
            </strong>
          </label>
          <input
            type="text"
            className={`form-control ${errors.roomsize ? "is-invalid" : ""}`}
            placeholder="Room Size"
            value={roomsize}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, roomsize: e.target.value }))
            }
            onKeyDown={(e) => {
              if (
                !/^\d*$/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete"
              ) {
                e.preventDefault();
                setErrors((prev) => ({
                  ...prev,
                  roomsize: "Only numbers are allowed.",
                }));
              } else {
                setErrors((prev) => ({ ...prev, roomsize: "" })); // Clear error
              }
            }}
          />
          {errors.roomsize && (
            <span className="text-danger">{errors.roomsize}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Upload Images (up to 5)
            </strong>
          </label>
          <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
            Note: Maximum upload size: 2MB, format: JPG
          </div>
          <DragDropContext onDragEnd={onImagesDragEnd}>
            <Upload
              listType="picture-card"
              multiple
              accept="image/*"
              beforeUpload={() => false}
              onChange={handleImageChange}
              onRemove={handleImageRemove}
              showUploadList={false}
              maxCount={5}
              style={{
                border: errors.imageFiles ? "1px solid red" : undefined,
                borderRadius: "4px",
                padding: "4px",
              }}
            >
              {imageFiles.length >= 5 ? null : uploadButton}
            </Upload>
            <Droppable droppableId="images" direction="horizontal">
              {(provided) => (
                <div
                  className="d-flex mt-2"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ gap: 8, overflowX: "auto", padding: "6px 4px" }}
                >
                  {(imageFiles || []).map((file, idx) => {
                    const src = file.url || URL.createObjectURL(file);
                    return (
                      <Draggable
                        key={file.uid || idx}
                        draggableId={String(file.uid || idx)}
                        index={idx}
                      >
                        {(draggableProvided) => (
                          <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.dragHandleProps}
                            style={{
                              width: 100,
                              height: 80,
                              border: "1px solid #e8e8e8",
                              borderRadius: 4,
                              position: "relative",
                              flex: "0 0 auto",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                              ...draggableProvided.draggableProps.style,
                            }}
                          >
                            {src ? (
                              <img
                                src={src}
                                alt={file.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <div style={{ fontSize: 12, color: "#888" }}>
                                {file.name}
                              </div>
                            )}
                            <button
                              type="button"
                              onClick={() => handleImageRemove(file)}
                              style={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                background: "rgba(0,0,0,0.6)",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: 20,
                                height: 20,
                                cursor: "pointer",
                                padding: 0,
                                lineHeight: "18px",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {errors.imageFiles && (
            <span className="text-danger">{errors.imageFiles}</span>
          )}
        </div>
        <div className="mb-2">
          <label>
            <strong>
              <span class="text-danger">*</span>Bedding
            </strong>
          </label>
          <select
            className="form-control"
            placeholder="Select Bed Type"
            value={bedding}
            onChange={(e) =>
              setRoom((prev) => ({ ...prev, bedding: e.target.value }))
            }
          >
            <option value="">Select Bed Type</option>
            {beddingOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {errors.bedding && (
            <span className="text-danger">{errors.bedding}</span>
          )}
        </div>

        {bedding === "Input No of Bed Manually" && (
          <div className="mb-2">
            <label>
              <strong>
                <span class="text-danger">*</span>Number of Beds
              </strong>
            </label>
            <input
              type="number"
              className="form-control"
              value={manualBeds}
              onChange={(e) =>
                setRoom((prev) => ({ ...prev, manualBeds: e.target.value }))
              }
            />
            {errors.manualBeds && (
              <span className="text-danger">{errors.manualBeds}</span>
            )}
          </div>
        )}

        <div className="mb-3">
          <label>
            <strong>
              <span class="text-danger">*</span>Facilities
            </strong>
          </label>
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%" }}
            placeholder="Select Facilities"
            value={facilities}
            onChange={handleFacilityChange}
          >
            {facilityOptions.map((facility) => (
              <Option key={facility} value={facility}>
                {facility}
              </Option>
            ))}
          </Select>
          {errors.facilities && (
            <span className="text-danger">{errors.facilities}</span>
          )}
        </div>

        <div className="mb-3">
          <label>
            <strong>Extra Bed</strong>
          </label>
          <div className="d-flex align-items-center">
            <Switch
              checked={extrabed}
              onChange={(checked) =>
                setRoom((prev) => ({ ...prev, extrabed: checked }))
              }
            />
            <span className="ms-2">{extrabed ? "Yes" : "No"}</span>
          </div>
        </div>

        <div className="mb-2">
          <label>
            <strong>Smoking Policy</strong>
          </label>
          <div className="d-flex align-items-center">
            <Switch
              checked={smokingpolicy}
              onChange={(checked) =>
                setRoom((prev) => ({ ...prev, smokingpolicy: checked }))
              }
            />
            <span className="ms-2">
              {smokingpolicy ? "Smoking Allowed" : "No Smoking"}
            </span>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <Button
            type="primary"
            onClick={addRoom}
            loading={loading} // Show loading spinner while saving
          >
            {loading ? "Saving..." : "Add Room"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddRoomTemplate;
